<template>
    <div class="publishhouse" style="width:800px">
            <form class="form_item">
                <el-row class="step_item">
                    <label class="label_title">*最短租期:</label>
                    <el-select class="mini_select" size="small" v-model="leaseTermValue" placeholder="请选择" @change="leaseTermChange">
                         <el-option
                          v-for="item in leaseTermOptions"
                          :key="item.KeyValue"
                          :label="item.KeyName"
                          :value="item.KeyValue">
                        </el-option>
                    </el-select>
                    <label>*最早可入住时间</label>
                    <el-date-picker
                     size="small"
                      v-model="checkinTimeValue"
                      type="date"
                      suffix-icon="el-icon-date"
                      placeholder="选择日期">
                    </el-date-picker>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">*小区:</label>
                    <el-autocomplete
                        style="width:436px"
                        v-model="firstObj.C_COMName"
                        :disabled=" status == 'edit' "
                        :fetch-suggestions="querySearchAsync"
                        value-key="C_COMName"
                        placeholder="请输入内容"
                        @select="handleSelect"
                    ></el-autocomplete>
                </el-row>  
                <el-row class="step_item">
                    <label class="label_title">*城市:</label>
                    <el-select class="mini_select" size="small" v-model="firstObj.Null2" placeholder="请选择" @change="getArea" :disabled="cityState">
                         <el-option
                          v-for="item in cityNameOptions"
                          :key="item.ID"
                          :label="item.C_ReachName"
                          :value="item.ID">
                        </el-option>
                    </el-select>
                    <label class="label_title">*区域:</label>
                    <el-select class="mini_select" size="small" v-model="firstObj.Null1" placeholder="请选择" @change="getBussness" :disabled="cityState">
                         <el-option
                          v-for="item in areaOptions"
                          :key="item.ID"
                          :label="item.C_ReachName"
                          :value="item.ID">
                        </el-option>
                    </el-select>
                    <label class="label_title">*商圈:</label>
                    <el-select class="mini_select" size="small" v-model="firstObj.Null3" placeholder="请选择" @change="getName" :disabled="cityState">
                         <el-option
                          v-for="item in bussnessOptions"
                          :key="item.ID"
                          :label="item.C_ReachName"
                          :value="item.ID">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">*房源类型:</label>
                    <el-radio v-model="radio" label="1">老洋房</el-radio>
                    <el-radio v-model="radio" label="2">别墅</el-radio>
                    <el-radio v-model="radio" label="3">公寓</el-radio>
                    <el-radio v-model="radio" label="4">服务式公寓</el-radio>
                    <el-radio v-model="radio" label="5">商住公寓</el-radio>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">栋号:</label><el-input size="small" class="mini_input" v-model="firstObj.Rid_ID" placeholder="请输入"></el-input>
                    <label class="label_title">单元</label><el-input size="small" class="mini_input" v-model="danyuan" placeholder="请输入"></el-input>
                    <label class="label_title">室号</label><el-input size="small" class="mini_input" v-model="shihao" placeholder="请输入"></el-input>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">*房源户型:</label>
                                <el-select class="mini_select" size="small" v-model="firstObj.Bedroom" placeholder="请选择">
                                    <el-option
                                    v-for="item in bedroomOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>室
                                <el-select class="mini_select" size="small" v-model="firstObj.room" placeholder="请选择">
                                    <el-option
                                    v-for="item in roomOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>厅
                                <el-select class="mini_select" size="small" v-model="firstObj.Washroom" placeholder="请选择">
                                    <el-option
                                    v-for="item in washroomOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>卫
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">*楼层:</label>
                    <el-select class="mini_select" size="small" v-model="firstObj.lc" placeholder="请选择">
                         <el-option
                          v-for="item in floorOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <label class="label_title">朝向</label>
                    <el-select class="mini_select" size="small" v-model="firstObj.cx" placeholder="请选择">
                         <el-option
                          v-for="item in faceOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <label class="label_title">面积</label><el-input size="small" class="mini_input" v-model="firstObj.RoomSize" placeholder="请输入"></el-input>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">*装修情况:</label>
                    <el-select class="mini_select" size="small" v-model="decorateValue" placeholder="请选择"  @change="decorateChange">
                         <el-option
                          v-for="item in decorateOptions"
                          :key="item.KeyValue"
                          :label="item.KeyName"
                          :value="item.KeyValue">
                        </el-option>
                    </el-select>
                </el-row>
                <el-row class="step_item">
                    <label class="label_title">家居配套:</label>
                    <el-checkbox-group v-model="checkedCities1" class="furnishings"  @change="furniturePackageChange">
                        <el-checkbox 
                         v-for="item in furniturePackage" 
                         :label="item.KeyName" 
                         :key="item.KeyValue" 
                         :value="item.KeyValue">{{item.KeyName}}</el-checkbox>
                    </el-checkbox-group>
                    <el-row class="parking_select">
                        <el-select class="mini_select "  size="mini" v-model="parkingValue" placeholder="请选择"  @change="parkingChange">
                             <el-option
                              v-for="item in parkingOptions"
                              :key="item.KeyValue"
                              :label="item.KeyName"
                              :value="item.KeyValue">
                            </el-option>
                        </el-select>停车位
                    </el-row>
                        
                </el-row>
            </form>
    </div>
</template>

<script>
const cityOptions = [{value:1,label:'电梯'},{value:2,label:'电视'}, {value:3,label:'空调'}, {value:4,label:'沙发'}, {value:5,label:'洗碗机'}, {value:6,label:'烤箱'}, {value:7,label:'微波炉'}, {value:8,label:'冰箱'}, {value:9,label:'消毒柜'}, {value:10,label:'净水机'}, {value:11,label:'热水器'}, {value:12,label:'天然气'}, {value:13,label:'浴缸'}, {value:14,label:'淋浴器'},{value:15,label:'智能马桶'},{value:16,label:'床'},{value:17,label:'洗衣机'},{value:18,label:'衣柜'},{value:19,label:'地暖'},{value:20,label:'墙暖'},{value:21,label:'商用电'},{value:22,label:'民用电'},{value:23,label:'商用水'},{value:24,label:'民用水'}];

export default {
    props:[
        "houseMessage",
        "status"
    ],
    data(){
        return {
            page: 1,
            cityState: false,
            furniturePackage: [],//配套
            leaseTermOptions: [],//最短租期
            decorateOptions: [],//装修情况
            parkingOptions: [],//停车位
            leaseTermValue: '',
            firstObj:{
                C_COMName:'',//楼盘名称
                communityBH: '',//楼盘编号
                communityID: '',//楼盘id
                Bedroom: '',//室
                Washroom: '',//卫
                room: '',//厅
                Rid_ID: '',//栋座id
                ridgepoleNo: '',//栋座编号
                WylxId: '',//物业类型ID
                Reach_ID: '',//地段id
                Null1: '',//区域ID 
                Null2: '',//城市ID
                Null3: '',
                a_c_Name: '',//城市名
                d_c_Name: '',//区域名
                b_c_Name: '',//商圈名
                C_Address: '',//地址（中） 
                House_NO: '',//房号
                C_Describe: '',//房屋描述（中）
                RoomSize: '',//总面积 
                FY_Subtitle_CN: '',//房源副标题(中)
                cx: '',//朝向
                lc: '',//楼层
                RoomSize: '',//面积
                TypeIds: [],//房源属性

            },
            checkinTimeValue:'',
            radio: '',
            donghao: '',
            shihao: '',
            danyuan: '',

            bedroomOptions: [{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}],
            
            roomOptions: [{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}],
           
            washroomOptions: [{value:'1',label:'1'},{value:'2',label:'2'},{value:'3',label:'3'}],
            
            parkingValue:'',
            
            floorOptions: [{value:'1',label:'10'},{value:'2',label:'20'},{value:'3',label:'30'}],
            
            faceOptions: [{value:'1',label:'东'},{value:'2',label:'西'},{value:'3',label:'南'},{value:'4',label:'北'}],
           
           
            
            decorateValue: '',
            checkedCities1: [],
            cities: cityOptions,
            cityNameOptions:[{C_ReachName:'上海',ID: '1'}],
            areaOptions:[],
            bussnessOptions:[]
        }
    },
    methods:{
        gethousefurniture(){
            //获取家居配套
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'furniture_package'},data => {
                this.furniturePackage = data
            },err => {

            })
        },
        gethouseParking(){
            //获取家居配套
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'parking_space'},data => {
                this.parkingOptions = data
            },err => {

            })
        },
        gethouseLease(){
            //最短租期
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'shortest_lease'},data => {
                this.leaseTermOptions = data
            },err => {

            })
        },
        gethouseCondition(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'renovation_condition'},data => {
                this.decorateOptions = data
            },err => {

            }) 
        },
        getCity(){
            //获取城市
            this.$get('/Handler/FYGL.ashx',{action:'GetReach',reachid:0},data => {
                this.cityNameOptions = data;
            },err => {

            }) 
        },
        getArea(id){
            //获取区域
            this.firstObj.Null3 = '';
            this.firstObj.Null1 = '';
            this.$get('/Handler/FYGL.ashx',{action:'GetReach',reachid:id},data => {
                this.areaOptions = data;
            },err => {

            });
            let that = this;
            this.cityNameOptions.forEach((item) => {
                if(item.ID === id){
                    that.firstObj.a_c_Name = item.C_ReachName
                    return
                }
            })

        },
        getBussness(id){
            //获取商圈
            this.firstObj.Null3 = '';
            this.$get('/Handler/FYGL.ashx',{action:'GetReach',reachid:id},data => {
                this.bussnessOptions = data
            },err => {

            });
            let that = this;
            this.areaOptions.forEach((item) => {
                if(item.ID === id){
                    that.firstObj.d_c_Name = item.C_ReachName
                    return
                }
            })
           
        },
        getName(val){
            let that = this;
            this.bussnessOptions.forEach((item) => {
                if(item.ID === val){
                    that.firstObj.b_c_Name = item.C_ReachName
                    return
                }
            })
        },
        leaseTermChange(val){
            //获取最短租期key-value
            var obj = {};
            obj = this.leaseTermOptions.find((item)=>{
                return item.KeyValue === val;
            });
            this.firstObj.TypeIds.push(obj.KeyValue+'-'+obj.Type);

        },
        decorateChange(val){
            //获取装修key-value
            var obj = {};
            obj = this.decorateOptions.find((item)=>{
                return item.KeyValue === val;
            });
            this.firstObj.TypeIds.push(obj.KeyValue+'-'+obj.Type);
            
        },
        furniturePackageChange(val){
            //获取配套KeyValue-Type
           
        },
        parkingChange(val){
            //获取配套key-value
            var obj = {};
            obj = this.parkingOptions.find((item)=>{
                return item.KeyValue === val;
            });
            this.firstObj.TypeIds.push(obj.KeyValue+'-'+obj.Type);
        },
        querySearchAsync(queryString,cb){
          this.$get('/Handler/FYGL.ashx',{Action:'selectCommunityList',COMName:this.firstObj.C_COMName}, data => {
              cb(data);
              this.cityState = false;
          },error => {
              this.$message.error(error);
          });
        },
        handleSelect(item) {
            // 这里的item会把一些初始化的对象变为undefined，导致了选其他的时候报错
            this.cityState = true;
            _.forEach(item , (value,key)=>{
                this.firstObj[key] = value;
            });
        },
        getValue(){
            return this.firstObj;
        }
    },
    created(){
        // this.firstObj = this.houseMessage;
        this.gethousefurniture();
        this.gethouseParking();
        this.gethouseLease();
        this.gethouseCondition();
        // this.getCity()
        this.getArea()
       
    }
}
</script>

<style scoped>
    .publishhouse .step_title{
        color: #278bdd;
        font-size: 14px;
        padding: 25px;
    }
    .publishhouse .step_item{
        margin-bottom: 20px;
        font-size: 14px;
        border-bottom: 1px dashed #efefef;
        padding-bottom: 20px;
        position: relative;
    }
    .publishhouse .step_item label.label_title{
        text-align: right;
        padding-right: 8px;
        min-width: 70px;
        display: inline-block;
    }
    .publishhouse .mini_input{
        display: inline-block;
        width: 100px;
    }
    .publishhouse .furnishings{
        display: inline-block;
    }
    .publishhouse .form_item{
        margin-left: 25px;
    }
    .publishhouse .mini_select{
        width: 100px;
        height: 40px;
    }
    .publishhouse .el-input__inner{
        height: 30px;
        line-height: 30px;
    }
    .publishhouse .el-input__icon{
        line-height: 30px;
    }
    
   .publishhouse .upload_demo{
        border: 1px dashed #efefef;
        padding: 20px;
        width: 80%;
        margin-top: 10px;
        min-height: 150px;
        text-align: center;
    }
    .publishhouse .el-upload--picture-card{
        border: none;
        width: 80px;
        height: 32px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .publishhouse .max_input{
        display: inline-block;
        width: 330px;
        margin-top: 10px;
    }
    .publishhouse .rent_demo,.self_demo{
        padding-left: 20px;
        margin-bottom: 10px;
    }
    .publishhouse .self_demo label{
        margin-right: 5px;
    }
    .publishhouse .rent_demo .radio_select{
        margin-left: 60px;
        margin-bottom: 15px;
    }
   .publishhouse .rent_demo .el-radio{
        margin-right: 20px;
    }
    .publishhouse .el-radio__label,.el-checkbox__label{
        padding-left: 3px;
    }
   .publishhouse .furnishings .el-checkbox{
        margin-right: 0;
        width: 78px;
        margin-bottom: 5px;
    }
   .publishhouse .parking_select{
        display: inline-block;
        padding-left: 77px;
    }
    .publishhouse .parking_select .mini_select{
        width: 80px;
        height: 20px;
    }
    .publishhouse .parking_select .el-input__inner{
        height: 20px;
        padding: 0 5px;
    }
    
    .publishhouse .parking_select .el-input__icon{
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/publishHouse/components/publishFist.vue